import React from 'react';
import NavBar from '../components/layout/NavBar';
import SiteFooter from '../components/layout/SiteFooter';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { webPageSchema, breadcrumbSchema } from '../schema';
import { CONTACT_EMAIL, LEGAL_ENTITY_NAME, LEGAL_ABN, LEGAL_ADDRESS, LEGAL_JURISDICTION } from '../seoConfig';

const Terms = () => (
  <div className="relative w-full min-h-screen">
    <SEO
      title="Terms of Service"
      description="The terms governing use of the SaniQ website and pre-launch waitlist registration."
      path="/terms"
      schema={[
        webPageSchema({ title: 'Terms of Service', description: 'SaniQ terms of service.', path: '/terms' }),
        breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Terms of Service', path: '/terms' }]),
      ]}
    />
    <NavBar />
    <Breadcrumbs trail={[{ name: 'Home', path: '/' }, { name: 'Terms of Service', path: '/terms' }]} />

    <section className="py-12 px-8 max-w-3xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-light text-white mb-3">Terms of Service</h1>
      <p className="text-white/40 text-sm mb-10">Effective date: 22 April 2026</p>

      <div className="space-y-6 text-sm text-white/60 leading-relaxed">
        <p>
          These Terms of Service (&ldquo;Terms&rdquo;) govern your use of this website, operated by {LEGAL_ENTITY_NAME ? `${LEGAL_ENTITY_NAME}${LEGAL_ABN ? ` (${LEGAL_ABN})` : ''}, trading as SaniQ` : 'SaniQ'}, based in {LEGAL_ADDRESS} (&ldquo;SaniQ,&rdquo; &ldquo;we,&rdquo; &ldquo;us&rdquo;). By using this site or joining the waitlist, you agree to these Terms.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Pre-Launch Status</h2>
        <p>
          SaniQ is a product in pre-launch development. Statements about product performance, specifications, pricing, and availability on this site (including &ldquo;99.9% germ elimination&rdquo; and &ldquo;2-3 seconds&rdquo; figures) reflect current design targets and testing to date, and are subject to change before commercial launch.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Waitlist Registration</h2>
        <p>
          Joining the waitlist is free and does not constitute a purchase, pre-order, or binding reservation. Founding-member pricing and priority access, where offered, will be confirmed separately closer to launch.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Acceptable Use</h2>
        <p>
          You agree not to misuse this website, including attempting to interfere with its normal operation, submitting false registration information, or using automated means to scrape or overload the site.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Intellectual Property</h2>
        <p>
          All content on this site, including text, graphics, product renderings, and the SaniQ name and logo, is owned by or licensed to SaniQ and may not be reproduced without permission.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Disclaimer of Warranties</h2>
        <p>
          This website and its content are provided &ldquo;as is&rdquo; without warranties of any kind, express or implied, to the maximum extent permitted by law, given the product's pre-launch status.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Limitation of Liability</h2>
        <p>
          To the maximum extent permitted by applicable law, SaniQ is not liable for any indirect, incidental, or consequential damages arising from use of this website or reliance on pre-launch product information.
        </p>

        <h2 className="text-white text-lg font-medium pt-4">Governing Law</h2>
        <p>These Terms are governed by the laws of {LEGAL_JURISDICTION}.</p>

        <h2 className="text-white text-lg font-medium pt-4">Changes to These Terms</h2>
        <p>We may update these Terms from time to time as the product and business develop ahead of launch. Continued use of the site after changes constitutes acceptance of the updated Terms.</p>

        <h2 className="text-white text-lg font-medium pt-4">Contact Us</h2>
        <p>
          Questions about these Terms can be sent to{' '}
          <span className="text-cyan-400">{CONTACT_EMAIL}</span>
          .
        </p>
      </div>
    </section>

    <SiteFooter />
  </div>
);

export default Terms;
